import { render, staticRenderFns } from "./deposit_details.vue?vue&type=template&id=4c9670c2"
import script from "./deposit_details.vue?vue&type=script&lang=js"
export * from "./deposit_details.vue?vue&type=script&lang=js"
import style0 from "./deposit_details.vue?vue&type=style&index=0&id=4c9670c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports